/* © CNES */

import moment from 'moment';
import {
  CLOUD_COVER,
  DATASET,
  END_DATE_TIME,
  GRID_CODE,
  IDENTIFIER,
  INSTRUMENT,
  INSTRUMENT_MODE,
  NODATA_PIXEL,
  ORBIT_ABSOLUTE,
  ORBIT_RELATIVE,
  PLATFORM,
  PPARAMETER,
  PROCESSING_LEVEL,
  PRODUCT_ACQUISITION_TYPE,
  PRODUCT_TYPE,
  START_DATE_TIME,
  VISIBILITY,
  WATER_COVER,
} from '../../components/shared/Constants';

/**
 * Filter Initial Values.
 */
export const FilterInitValues = {
  [ORBIT_ABSOLUTE]: null,
  [ORBIT_RELATIVE]: null,
  [DATASET]: null,
  dataProduct: null,
  [PLATFORM]: null,
  [PRODUCT_TYPE]: null,
  [PROCESSING_LEVEL]: null,
  [INSTRUMENT_MODE]: null,
  [CLOUD_COVER]: null,
  [START_DATE_TIME]: null,
  [END_DATE_TIME]: moment()
    .utc()
    .subtract(1, 'days')
    .startOf('day')
    .toISOString(),
  [IDENTIFIER]: null,
  [PPARAMETER]: null,
  [INSTRUMENT]: null,
  [GRID_CODE]: null,
  [WATER_COVER]: null,
  [NODATA_PIXEL]: null,
  [PRODUCT_ACQUISITION_TYPE]: null,
  [VISIBILITY]: null,
};

export const subMissionInitValues = {
  [DATASET]: null,
  [PLATFORM]: null,
  [PRODUCT_TYPE]: null,
  [PROCESSING_LEVEL]: null,
  [INSTRUMENT_MODE]: null,
  [CLOUD_COVER]: null,
};
